import React from 'react'
import { flatten, values } from 'ramda'
import { Modal } from '@zambezi/sdk/modal'
import Accordion from '@zambezi/sdk/accordion'
import classNames from 'classnames'

import modalStyle from '@apiEnabler/ob-common/lib/view/modal.module.css'

export default function StatusMeaningModal({ open, onClose, sections, title }) {
  return (
    <Modal
      className={`${modalStyle.modal} js-modal`}
      withBackdrop
      withPadding={false}
      title={title}
      open={open}
      confirm="Close"
      onCancel={onClose}
      onConfirm={onClose}
    >
      <div className="js-status-meaning-list">
        <Accordion openItems={[0]}>
          {statusSections(sections).map((section, index) => (
            <div
              key={index}
              className={classNames(
                index % 2
                  ? `js-description-${section.index}`
                  : `js-name-${section.index}`,
                'accordion-item-description'
              )}
            >
              {section.value}
            </div>
          ))}
        </Accordion>
      </div>
    </Modal>
  )
}

function statusSections(accessSections) {
  return flatten(
    values(accessSections).map(section => [
      {
        value: section.label,
        index: section.label.toLowerCase(),
      },
      { value: section.description, index: section.label.toLowerCase() },
    ])
  )
}
